/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  HealthControllerCheckReadinessQueryResponse,
  HealthControllerCheckReadiness503,
} from '../../types/HealthControllerCheckReadiness.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { healthCheckReadiness } from '../../methods/healthCheckReadiness.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const healthCheckReadinessQueryKey = () => [{ url: '/api/health/readiness' }] as const;

export type HealthCheckReadinessQueryKey = ReturnType<typeof healthCheckReadinessQueryKey>;

export function healthCheckReadinessQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = healthCheckReadinessQueryKey();
  return queryOptions<
    HealthControllerCheckReadinessQueryResponse,
    ResponseErrorConfig<HealthControllerCheckReadiness503>,
    HealthControllerCheckReadinessQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return healthCheckReadiness(config);
    },
  });
}

/**
 * {@link /api/health/readiness}
 */
export function useHealthCheckReadiness<
  TData = HealthControllerCheckReadinessQueryResponse,
  TQueryData = HealthControllerCheckReadinessQueryResponse,
  TQueryKey extends QueryKey = HealthCheckReadinessQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        HealthControllerCheckReadinessQueryResponse,
        ResponseErrorConfig<HealthControllerCheckReadiness503>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? healthCheckReadinessQueryKey();

  const query = useQuery(
    {
      ...healthCheckReadinessQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<HealthControllerCheckReadiness503>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
